import { render, staticRenderFns } from "./Section8.vue?vue&type=template&id=3576084e&"
import script from "./Section8.vue?vue&type=script&lang=js&"
export * from "./Section8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports